import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled, { withTheme } from 'styled-components'
import MaterialTabs from '@material-ui/core/Tabs'
import TabsItem from '../TabsItem'
import ResizeDetector from '../ResizeDetector'

const StyledMaterialTabs = styled(MaterialTabs)`
  & .indicator {
    background-color: ${(props) => (props.indicatorColor ? props.indicatorColor : props.theme.color.stol)};
    margin-top: 1px;
    width: 100%;
  }
`
class Tabs extends Component {
  constructor(props) {
    super(props)
    this.state = {
      variant: 'fullWidth',
    }
    this.resizeHandler = this.resizeHandler.bind(this)
  }
  resizeHandler(boundingClientRect) {
    if (boundingClientRect.width <= this.props.switchscrollablefrom) {
      this.setState({
        variant: 'scrollable',
      })
    } else {
      this.setState({
        variant: 'fullWidth',
      })
    }
  }
  render() {
    const { children, indicatorColor, ...props } = this.props
    return (
      <ResizeDetector onResize={this.resizeHandler}>
        <StyledMaterialTabs
          variant={this.state.variant}
          indicatorColor={indicatorColor}
          textColor={props.theme.color.stol}
          scrollButtons="auto"
          {...props}
          classes={{ indicator: 'indicator', flexContainer: 'flexContainer' }}
        >
          {children}
        </StyledMaterialTabs>
      </ResizeDetector>
    )
  }
}

Tabs.defaultProps = {
  switchscrollablefrom: 450,
}

Tabs.propTypes = {
  children: PropTypes.arrayOf(TabsItem),
}

export default withTheme(Tabs)
